
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import teacherCard from '@/components/teacher-card.vue';
import teacherList from '@/components/teacher-list.vue';
export default {
components: {
teacherCard,
teacherList
},
name: 'teacher-lists',
data() {
return {
ishalf: true
};
},
methods: {

tabteacher(e) {
if (e === '50') {
this.ishalf = true;
} else {
this.ishalf = false;
}
}
},
watch: {},
computed: {

},
created() {},
mounted() {}
};
